import asyncComponent from '../AsyncComponent';

// @ts-ignore
const AsyncDatePicker = asyncComponent(() => import('react-color/lib/Compact'));

export default AsyncDatePicker;
